import * as utils from '../utils';
import { WebDriver } from './webdriver';
import { TimeoutError } from '../errors';

export class ExtensionTestPlayer {
    driver = new WebDriver();
    constructor(public readonly id: number) {
    }

    async onDone() {
        const END_DRIVER_TIMEOUT = 1000 * 60 * 2;
        try {
            await utils.promiseTimeout(this.driver.end(), END_DRIVER_TIMEOUT);
        } catch (error) {
            if (error instanceof TimeoutError) {
                await this.driver.forceEnd().catch(() => null);
            }
        }
        // @ts-expect-error why do we need to make this null?
        this.driver = null;
    }

    getSessionId() {
        return this.driver.getSessionId();
    }
}
